import * as React from 'react'
import * as Icon from 'react-bootstrap-icons'

import { Box } from '@mui/material'
import { Accordion, Button, Card, Image, Tabs, Tab } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import * as _ from 'lodash'
import BillOfLading from './BillOfLading/BillOfLading'
import ClientAgreement from './ClientAgreement/ClientAgreement'
import ConsumerRightsAndResponsibilities from './ConsumerRightsAndResponsibilities/ConsumerRightsAndResponsibilities'
import CreditCardAuthorization, { CreditCardAuthorizationObj, CreditCardAuthorizationT } from './CreditCardAuthorization/CreditCardAuthorization'
import CubeSheet from './CubeSheet/CubeSheet'
import Estimate from './Estimate/Estimate'
import Invoice from './Invoice/Invoice'
import { JobMode } from '../Job'
import { copyObject, convertArrayToObject } from '../../../../utils'
// Colorado
import ConsumerAdvisement from './StateDocuments/Colorado/ConsumerAdvisement'
import { CompanyT } from '../../../../types/Company'
import { VariableDocumentT, variablesToObject } from './DocumentVariables'
import { ClientAgreementT } from './ClientAgreement/ClientAgreement'
import { filterDocuments, ConfigDocumentsT } from './ConfigDocuments'
import ColoradoClientAgreement from './ClientAgreement/Colorado/ColoradoClientAgreement'

import { AxiosInstance } from '../../../../utils/RequestMethods'
import config from '../../../../constants/config'

import axios from 'axios'
import ButtonLoading from '../../../../components/ButtonLoading/ButtonLoading'
import { prepareDocuments } from '../Filters/FilterDocuments'
import { DocumentT, EstimateT, InvoiceT, JobStatusT, JobT } from '../../../../types/Job'
import { IAppState } from '../../../../redux/reducers'
import { JobWorkerObj } from '../../../../types/JobWorker'
import { useImmer } from 'use-immer'
import Receipt from './Receipt/Receipt'
import { JobObj } from '../InitObjectJob'






interface DocumentsTabProps {
  company: CompanyT
  job: JobT
  jobOrigin: JobT
  jobMode: JobMode
  updateJob(key: string, value: any): void
  refreshJob(newJob: JobT): void
  saveJob(): Promise<JobT>
  tabIsActive: boolean
}

const DocumentsTab: React.FunctionComponent<DocumentsTabProps> = (props): JSX.Element => {

  const [activeKeyAccordion, setActiveKeyAccordion] = React.useState(null)
  const [currentDocuments, setCurrentDocuments] = React.useState(null)
  const [currentListDocuments, setCurrentListDocuments] = React.useState([])
  // const [jobDocuments, setJobDocuments] = React.useState(null)
  const [tempJobType, setTempJobType] = React.useState(null)
  const [tempJobStatus, setTempJobStatus] = React.useState(null)
  const [tempJobState, setTempJobState] = React.useState(null)
  const [isReady, setIsReady] = React.useState(false)

  const [open, setOpen] = React.useState(false)
  let auth = useSelector((state: IAppState) => state.auth)
  const userRole = auth.userData && auth.userData.roles ? auth.userData.roles[0] : []
  const [currentJob, setCurrentJob] = React.useState<JobT>(copyObject(JobObj));
  const [activeTab, setActiveTab] = React.useState("");


  React.useEffect(() => {
    if (!_.isEqual(props.job, currentJob)) {
      console.log("render->documents->job")
      setCurrentJob(props.job)
      setIsReady(true)
    }
  }, [props.job]);

  // onChangeAccordion
  const onChangeAccordion = (index: number): void => {
    if (index < 0) {
      index = 0
    }
    if (index != activeKeyAccordion) setActiveKeyAccordion(index)
    else setActiveKeyAccordion(null)
  }


  React.useEffect((): void => {
    let currDoc = null
    const addressState = _.isArray(props.job.locations) && props.job.locations[0] && props.job.locations[0].addressState

    if (!_.isEqual(tempJobType, props.job.jobType) || !_.isEqual(tempJobStatus, props.job.jobStatus) || !_.isEqual(tempJobState, addressState)) {

      setTempJobState(addressState)
      setTempJobType(props.job.jobType)
      setTempJobStatus(props.job.jobStatus)
      const [listDocuments, jobDocuments] = prepareDocuments(props.job)
      let filterListDocuments = []

      listDocuments.map((item, index) => {
        switch (item.name) {
          case 'invoice':
            if ((userRole.includes('administrator') || userRole.includes('manager') || userRole.includes('worker'))
              || (userRole.includes('client') && props.job.jobStatus == JobStatusT.completed)) {
              filterListDocuments.push(item)
            }
            break;
          case 'estimate':

            // remove estimate from Accordion because is will display in Client Agreement
            if ((props.job.jobType == 'interstate' || props.job.jobType == 'international') || (props.job.jobType == 'intrastate_long' && props.job.locations[0].addressState == 'Colorado')) {
              filterListDocuments.push(item)
            }
            break;
          default:
            filterListDocuments.push(item)
            break;
        }

      })

      setCurrentListDocuments(filterListDocuments);
      /**
       * open first tab
       */
      setInitTab(filterListDocuments)

      currDoc = copyObject(convertArrayToObject(jobDocuments, 'name'))
      setCurrentDocuments(currDoc)
    }
    // is change when receive refresh documents from socket
    if (currDoc == null && !_.isEqual(currentDocuments, props.job.documents)) {
      console.log("setCurrentDocuments", props.job.documents)

      setCurrentDocuments(props.job.documents)

    }

  }, [currentJob.documents, currentJob.jobType, currentJob.jobStatus, currentJob.locations])



  const setInitTab = (documents: Array<ConfigDocumentsT>) => {
    if (_.isArray(documents) && documents.length > 0) {
      setActiveTab(documents[0].name)
    }
  }

  const updateDocument = (key: string, value: any) => {

    // setCurrentDocuments((draft) => {
    //     draft[key] = value
    //     // return draft
    // })

    let cloneDocuments = Object.assign({}, currentDocuments)
    cloneDocuments[key] = value
    console.log("cloneDocuments", cloneDocuments)
    props.updateJob('documents', cloneDocuments)
    setCurrentDocuments(cloneDocuments)
  }

  const getDocumentsAgreements = (newJob: JobT): [Array<DocumentT>, Array<DocumentT>] => {
    let documents = newJob.documents;
    let documentsAgreements = []
    let documentsAgreed = []
    Object.keys(documents).map((key, index) => {
      let document: DocumentT = documents[key]
      // console.log(`document->${key} :`, document)
      if (document.active && document.agreement) {
        documentsAgreements.push(document)
        if (checkDocumentIsAgreed(document, document.variables)) {
          documentsAgreed.push(document)
        }
      }
    })

    return [documentsAgreements, documentsAgreed]
    //return infoClientAgreement;
  }

  const checkDocumentIsAgreed = (document: DocumentT, variables: Array<VariableDocumentT>) => {
    if (document.agreement && _.isArray(document.agreement)) {
      return document.agreement.find(agreement => {
        return _.isEqual(agreement.content, variables)
      });
    }
    return false;
  }

  // goToRequiredAgreement
  const goToRequiredAgreement = (): void => {
    const [documentsAgreements, documentsAgreed] = getDocumentsAgreements(props.job)
    let documentsNotAgreed: Array<DocumentT> = documentsAgreements.filter((x) => {
      if (!documentsAgreed.find((d) => d.name == x.name)) {
        return x;
      }
    })

    if (documentsNotAgreed && documentsNotAgreed[0]) {
      let indexAccordion = -1;
      // documentsNotAgreed[0].name
      let documentA = documentsNotAgreed[0]

      if (documentA.name == 'estimate' && !currentListDocuments.find((d) => d.name == "estimate")) {
        let searchAgreements = ['clientAgreement', 'coloradoClientAgreement']
        indexAccordion = currentListDocuments.findIndex((x) => searchAgreements.includes(x.name))
      } else {
        indexAccordion = currentListDocuments.findIndex((x) => x.name == documentA.name)

      }
      if (indexAccordion != -1 && activeKeyAccordion != indexAccordion) {
        onChangeAccordion(indexAccordion)
      }
      setTimeout(
        () => {
          const element = document.getElementById(`anchor-agreement-${documentA.name}`);
          //console.log("element", element)
          if (element) {
            element.scrollIntoView();
          }
        },
        200
      );
    }
  }



  const downloadPdf2 = async (newJob: JobT, doc: ConfigDocumentsT): Promise<string> => {
    console.log('downPDF: ', doc)
    // debugger

    if (!newJob.documents[doc.name]) {
      throw new Error('Plase save job.');
    }
    console.log("doc.name", doc.name)
    let document: DocumentT = newJob.documents[doc.name]
    if (!doc.template) {
      throw new Error('Template not found.');
    }
    let data = doc.generateTemplateData ? doc.generateTemplateData(props.job, document, props.job.companyInfo, newJob.client) : variablesToObject(document.variables)
    const fileName = `${doc.title}-${props.company.name}${newJob.client.firstName != '' && newJob.client.lastName != '' ? `-${newJob.client.firstName} ${newJob.client.lastName}` : ''}`
    let params = {
      template: doc.template,
      data: data,
      options: {
        ...{
          file_name: fileName,
        }, ...doc.optionsTemplate
      }
    }
    try {
      const resDownload = await AxiosInstance.post(`${config.url.jobs}/${newJob.id}/documents`, params)
      if (resDownload && resDownload.data) {
        // window.location =  res.data.download_link
        var link = window.document.createElement('a');

        window.document.body.appendChild(link);
        link.href = resDownload.data.download_link;
        // link.target = '_blank'
        // link.text= ""
        console.log("res.data.download_link", resDownload.data.download_link)
        setTimeout(() => {
          // window.open(resDownload.data.download_link,"_blank")
          link.click();
          link.remove();
        }, 2000);
        return 'PDF Generated.';
      }
    } catch (error) {
      throw error
    }
  }

  const nextDocument = (): void => {
    goToRequiredAgreement();
  }

  const renderTrackerAgreements = (job: JobT): JSX.Element => {

    const [documentsAgreements, documentsAgreed] = getDocumentsAgreements(job)
    return (
      <div style={{ margin: 5 }} className="font-weight-bold">
        <span className={`${documentsAgreements.length > 0 && documentsAgreements.length == documentsAgreed.length ? 'text-success' : 'text-danger'}`}>
          {`${documentsAgreed.length}/${documentsAgreements.length}`} required agreements
          {documentsAgreements.length != documentsAgreed.length && <button
            style={{
              padding: 0,
              margin: 0
            }}
            className="btn btn-link"
            onClick={(e) => {
              e.preventDefault()
              goToRequiredAgreement()
            }}>
            Go to required agreement {`${documentsAgreed.length + 1}/${documentsAgreements.length}`}.
          </button>}
        </span>
      </div>
    )
  }




  const addDocument = (docType: string, index: number, isActive = false): JSX.Element => {
    switch (docType) {
      case 'billOfLading':
        return <BillOfLading
          isActive={isActive}
          updateDocument={updateDocument}
          job={currentJob}
          jobOrigin={props.jobOrigin}
        />
      case 'clientAgreement':
        return <ClientAgreement
          updateDocument={updateDocument}
          company={props.company}
          job={currentJob}
          jobOrigin={props.jobOrigin}
          jobMode={props.jobMode}
          nextDocument={nextDocument}
          refreshJob={props.refreshJob}
          saveJob={props.saveJob}
          updateJob={props.updateJob} />
      case 'coloradoClientAgreement':
        return <ColoradoClientAgreement
          updateDocument={updateDocument}
          company={props.company}
          job={currentJob}
          jobOrigin={props.jobOrigin}
          jobMode={props.jobMode}
          nextDocument={nextDocument}
          refreshJob={props.refreshJob}
          saveJob={props.saveJob}
          updateJob={props.updateJob} />
      case 'consumerRights':
        return <ConsumerRightsAndResponsibilities />
      case 'creditCardAuthorization':
        return <CreditCardAuthorization />
      case 'cubeSheet':
        return <CubeSheet
          job={props.job}
          updateDocument={updateDocument}
          updateJob={props.updateJob} />
      case 'estimate':
        return <Estimate
          updateDocument={updateDocument}
          job={currentJob}
          jobOrigin={props.jobOrigin}
          jobMode={props.jobMode}
          nextDocument={nextDocument}
          refreshJob={props.refreshJob}
          saveJob={props.saveJob}
          updateJob={props.updateJob} />
      case 'invoice':
        return <Invoice
          isActive={isActive}
          updateDocument={updateDocument}
          company={props.company}
          job={currentJob}
          jobOrigin={props.jobOrigin}
          updateJob={props.updateJob} />

      // Colorado
      case 'consumerAdvisement':
        return <ConsumerAdvisement
          company={props.company}
          job={currentJob}
          jobOrigin={props.jobOrigin}
          jobMode={props.jobMode}
          nextDocument={nextDocument}
          refreshJob={props.refreshJob}
          saveJob={props.saveJob}
          updateJob={props.updateJob}
        />
      case 'receipt':
        return <Receipt
          isActive={isActive}
          updateDocument={updateDocument}
          company={props.company}
          job={currentJob}
          jobOrigin={props.jobOrigin}
          updateJob={props.updateJob} />

      /*case 'Inventory Sheet':
          return <InventorySheet />*/
      default:
        return null
    }
  }

  const renderTabs = () => {
    return (
      <Tabs
        variant='pills'
        // defaultActiveKey=''
        id='documentsTab'
        activeKey={`${activeTab}`}
        onSelect={(key: string) => {
          setActiveTab(key)
        }}>
        {currentListDocuments.map((item: ConfigDocumentsT, index) => {
          return (
            <Tab
              key={index}
              eventKey={item.name}
              title={item.title}>
              <div className='d-flex flex-column'>
                <div className='d-flex justify-content-end'>
                  <ButtonLoading
                    className="btn btn-link"
                    // style={{ height: 30 }}
                    onClickFetching={async (e): Promise<string> => {
                      try {
                        e.stopPropagation();
                        return await downloadPdf2(props.jobOrigin, item)
                        // return 'success';
                      } catch (error) {
                        throw new Error(error);
                      }
                    }}
                    customResponseMessage={(msg, status) => {
                      if (status) {
                        return (
                          <i className='fa fa fa-check text-success'></i>
                        )
                      }
                      return <span>{msg}</span>
                    }}
                  >
                    <Icon.Download className='ml-1' style={{ fontSize: 30, fontWeight: "bold" }} />
                  </ButtonLoading>
                </div>
                <div className='d-flex'>
                  {addDocument(item.name, index, item.name == activeTab)}
                </div>
              </div>
            </Tab>
          )
        })}
      </Tabs>
    )
  }

  if (!props.tabIsActive) {
    return null
  }

  return (
    <>
      {props.jobMode == JobMode.Edit && renderTrackerAgreements(props.job)}
      {renderTabs()}


    </>
  )
}

export default DocumentsTab
